module.exports = __webpack_public_path__ + "img/logo-greenn.4a365d1a.png";